import {
  StyledCategoryFilters,
  StyledFilterSeparator
} from './CategoryFilters.style';
import { onCategoryFilterChange } from '../../../useFormState/form.state.actions';
import FilterSelector from './FilterSelector';

const CategoryFilters = ({ category, pmFilters, dispatch }) => {
  const MAX_RULES = 3;
  const rules = category.filters || [];

  return (
    <StyledCategoryFilters>
      {rules.map((selectedFilters, idx) => (
        <>
          <FilterSelector
            key={idx}
            selectedFilters={selectedFilters}
            pmFilters={pmFilters}
            onCategoryFilterChange={newFilters =>
              dispatch(onCategoryFilterChange(category, newFilters, idx))
            }
            filterIdx={idx}
          />
          {idx !== MAX_RULES - 1 && (
            <StyledFilterSeparator>OR</StyledFilterSeparator>
          )}
        </>
      ))}
      {rules.length < MAX_RULES && (
        <FilterSelector
          selectedFilters={{}}
          pmFilters={pmFilters}
          onCategoryFilterChange={newFilters =>
            dispatch(onCategoryFilterChange(category, newFilters, rules.length))
          }
          filterIdx={rules.length}
        />
      )}
    </StyledCategoryFilters>
  );
};

export default CategoryFilters;
